<template>
    <Header
        elements="8"
        current="3"
    ></Header>
    <NumberPageBlock
        form_type="SOU"
        part_url="statement-of-use"
        part_url_next="step-owners"
        deadline_word="Upcoming Deadline"
    ></NumberPageBlock>
</template>

<script>
import Header from '@/components/Header-Short-New.vue'
import NumberPageBlock from '@/components/blocks/NumberPageBlock.vue'
import {to_top} from "@/helper";

export default {
    components: {
        Header,
        NumberPageBlock
    },
    data() {
        return {}
    },
    mounted() {
        to_top()
        this.$store.commit('header/setTotal', 0)
    }
}
</script>

